<template>
  <svg
    :width="width ? width : height ? height * (24 / 14) : 24"
    :height="height ? height : width ? width * (14 / 24) : 14"
    viewBox="0 0 24 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M18.71 4.74c-.56 0-1.1.1-1.6.3L14.4.7a.83.83 0 0 0-.7-.4h-2.22c-.31 0-.56.25-.56.56v.55c0 .3.25.56.56.56h1.75l.52.83H9.82v-.56c0-.3-.25-.55-.55-.55H6.24a.85.85 0 0 0-.85.85c0 .45.37.81.83.81H7.9L6.89 5a4.43 4.43 0 1 0 2.8 5.29h1.8c.28 0 .55-.15.7-.4l2.98-4.81.52.83a4.43 4.43 0 0 0 2.96 7.7 4.44 4.44 0 1 0 .06-8.87zM7.42 7.3c.34.36.58.82.68 1.32H6.6l.82-1.32zM5.4 11.95a2.78 2.78 0 1 1 .59-5.48L4.4 9.02a.83.83 0 0 0 .7 1.27h2.83a2.78 2.78 0 0 1-2.54 1.66zm5.63-3.33H9.8a4.43 4.43 0 0 0-1.47-2.77l.86-1.39h4.42l-2.58 4.16zm7.53 3.33a2.78 2.78 0 0 1-1.95-4.58l1.54 2.48c.16.26.5.34.76.18l.47-.3c.26-.15.34-.5.18-.76L18.01 6.5a2.77 2.77 0 1 1 .54 5.46z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'bike',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
